'use strict';

/*@ngInject*/
module.exports = function($rootScope, $scope, $state, $translate) {
	$rootScope.title = $translate.instant('pages.titles.articles');

	$scope.pages = 1;
	$state.feedPage = $scope.page;

	$scope.loadMore = function() {
		$state.feedPage = $scope.pages;
	};
};